
import axios from 'axios'
import { BASE_API, BASE_PATH_API, BASE_PORT_API } from '../config/config'
import { isShowLoading, toast } from '../helpers/functions/main';
import _ from 'lodash';
import { handleCheckMaintenance } from '../helpers/functions/auth';
import { storeGetState } from '../stores';
import { LOCAL_STORAGE } from "../helpers/constants/localStorage";
import { firebaseUnsubscribeNoti } from "../helpers/firebases/firebaseNotification";
import { removeLocalStorage } from "../helpers/functions/localStorage";

const getCookie = () => {
  const name = 'tb.oauth.azure.cross'
  let cookieValue;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const getConfig = (configService, params) => {
  const config = {
    baseURL: configService.baseApiPath ? configService.baseApiPath : BASE_API + BASE_PORT_API + BASE_PATH_API,
    onUploadProgress: (progressEvent) => {
      if (configService.onUploadProgress) {
        configService.onUploadProgress(Math.round(progressEvent.loaded * 100 / progressEvent.total));
      }
    },
    onDownloadProgress: (progressEvent) => {
      if (configService.onDownloadProgress) {
        configService.onDownloadProgress(Math.round(progressEvent.loaded * 100 / progressEvent.total));
      }
    },
    headers: {
      'X-CROSS-TB': getCookie()
    },
    params: configService.params,
    data: configService.data,
    withCredentials: true,
  }
  return config
}

const refreshInstance = axios.create();
let logoutCalled = false;

const logout = async () => {
  console.log('Logging out...');
  if (!logoutCalled) {
    logoutCalled = true;
    firebaseUnsubscribeNoti();
    removeLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
    window.location.href = `${BASE_API}${BASE_PORT_API}/oauth/sign-out-url`;
    setTimeout(() => {
      logoutCalled = false;
    }, 1000);
  }
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.message !== 'Unauthorized') {
        logout();
      }
      originalRequest._retry = true;
      try {
        await refreshInstance.post(`${BASE_API}${BASE_PORT_API}/oauth/refresh-token`, {}, {
          withCredentials: true
        });
        return axios(originalRequest);
      } catch (refreshError) {
        logout();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

const axiosSuccess = (res, configService) => {
  console.log('axiosSuccess', res);
  const _isShowLoading = configService.isShowLoading !== undefined ? configService.isShowLoading : true;
  if (_isShowLoading) {
    isShowLoading(false);
  }
  return res.data
}

const axiosError = (error, configService) => {
  const _isShowLoading = configService.isShowLoading !== undefined ? configService.isShowLoading : true;
  if (_isShowLoading) {
    isShowLoading(false);
  }
  console.log('error', { error });
  if (error.response && error.response.status === 401) {
    return false
  }
  const message = _.get(error, 'response.data.message', error.message);
  const _isShowError = configService.isShowError !== undefined ? configService.isShowError : true;
  if (_isShowError) {
    toast.error(message);
  }
  const _isReturnError = configService.isReturnError !== undefined ? configService.isReturnError : false;

  if (_isReturnError && error.response.data) {
    return error.response.data
  } else {
    return false
  }
}

const handleConfigService = (configService) => {
  const _isShowLoading = configService.isShowLoading !== undefined ? configService.isShowLoading : true;
  if (_isShowLoading) {
    isShowLoading(true);
  }
}

const axiosService = (type, url, params, configService) => {
  const config = getConfig(configService, params);
  handleConfigService(configService);
  if (configService.urlParams) {
    Object.keys(configService.urlParams).forEach((key, i) => {
      if (i === 0) {
        url = `${url}?`
      }
      else {
        url = `${url}&`
      }
      url = `${url}${key}=${configService.urlParams[key]}`
    })
  }
  console.log('params', params, url);
  switch (type) {
    case 'get': return axios.get(url, config).then(res => axiosSuccess(res, configService)).catch(err => axiosError(err, configService))
    case 'post': return axios.post(url, params, config).then(res => axiosSuccess(res, configService)).catch(err => axiosError(err, configService))
    case 'put': return axios.put(url, params, config).then(res => axiosSuccess(res, configService)).catch(err => axiosError(err, configService))
    case 'patch': return axios.patch(url, params, config).then(res => axiosSuccess(res, configService)).catch(err => axiosError(err, configService))
    case 'delete': return axios.delete(url, { ...config, data: params }).then(res => axiosSuccess(res, configService)).catch(err => axiosError(err, configService))
    default: return false
  }
}


export default (configService = {}) => {
  const maintenanceData = storeGetState().mainRedux.maintenance;
  const isCanUseApp = handleCheckMaintenance();
  const createAxiosService = (type, url, params) => {
    if (isCanUseApp) {
      return axiosService(type, url, params, configService)
    } else {
      // check call login
      if (maintenanceData.apiBeforeLoginWhiteList.indexOf(url) >= 0) {
        return axiosService(type, url, params, configService)
      }
    }

    return false
  }

  return {
    get: (url, params) => createAxiosService('get', url, params),
    post: (url, params) => createAxiosService('post', url, params),
    put: (url, params) => createAxiosService('put', url, params),
    patch: (url, params) => createAxiosService('patch', url, params),
    delete: (url, params) => createAxiosService('delete', url, params),
  }
}